import Input from '@/components/ui/Input';
import Select from '@/components/ui/Select';
import CheckboxGrid from '@/components/ui/CheckboxGrid';
import {
  RESEAU_OPTIONS,
  ASSAINISSEMENT_OPTIONS,
  EQUIPEMENT_CONFORT_OPTIONS,
} from '@/constants/enums';

export default function SectionEquipements({ data, onChange }) {
  const val = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? '';
  const arrVal = (field) => field.split('.').reduce((obj, key) => obj?.[key], data) ?? [];

  const handleChange = (field) => (e) => onChange(field, e.target.value);

  return (
    <div className="space-y-8">
      {/* ── Équipements techniques ── */}
      <section className="space-y-6">
        <h3 className="text-lg font-semibold text-slate-900">Réseaux et assainissement</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <CheckboxGrid
            label="Réseaux"
            name="equipements.reseaux"
            value={arrVal('equipements.reseaux')}
            options={RESEAU_OPTIONS}
            columns={2}
            onChange={(value) => onChange('equipements.reseaux', value)}
          />
          <Select
            label="Assainissement"
            name="equipements.assainissement"
            value={val('equipements.assainissement')}
            options={ASSAINISSEMENT_OPTIONS}
            onChange={handleChange('equipements.assainissement')}
          />
        </div>

        <h3 className="text-lg font-semibold text-slate-900">Chauffage et eau chaude</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Input
            label="Type de chauffage"
            name="equipements.chauffage_type"
            value={val('equipements.chauffage_type')}
            onChange={handleChange('equipements.chauffage_type')}
          />
          <Input
            label="Alimentation"
            name="equipements.chauffage_alimentation"
            value={val('equipements.chauffage_alimentation')}
            onChange={handleChange('equipements.chauffage_alimentation')}
          />
          <Input
            label="Diffusion"
            name="equipements.chauffage_diffusion"
            value={val('equipements.chauffage_diffusion')}
            onChange={handleChange('equipements.chauffage_diffusion')}
          />
          <Input
            label="Eau chaude sanitaire"
            name="equipements.eau_chaude"
            value={val('equipements.eau_chaude')}
            onChange={handleChange('equipements.eau_chaude')}
          />
        </div>

        <h3 className="text-lg font-semibold text-slate-900">Équipements de confort</h3>
        <CheckboxGrid
          label="Équipements de confort"
          name="equipements.equipements_confort"
          value={arrVal('equipements.equipements_confort')}
          options={EQUIPEMENT_CONFORT_OPTIONS}
          columns={2}
          onChange={(value) => onChange('equipements.equipements_confort', value)}
        />

        <h3 className="text-lg font-semibold text-slate-900">Éléments extérieurs</h3>

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.equipements?.terrasse?.surface_m2}
            onChange={(e) => {
              if (!e.target.checked) {
                onChange('equipements.terrasse', null);
              } else {
                onChange('equipements.terrasse.surface_m2', 0);
              }
            }}
            className="rounded border-slate-300"
          />
          Terrasse
        </label>

        {data?.equipements?.terrasse && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Surface (m²)"
              name="equipements.terrasse.surface_m2"
              type="number"
              value={val('equipements.terrasse.surface_m2')}
              onChange={handleChange('equipements.terrasse.surface_m2')}
            />
            <Input
              label="Revêtement"
              name="equipements.terrasse.revetement"
              value={val('equipements.terrasse.revetement')}
              onChange={handleChange('equipements.terrasse.revetement')}
            />
            <Input
              label="Exposition"
              name="equipements.terrasse.exposition"
              value={val('equipements.terrasse.exposition')}
              onChange={handleChange('equipements.terrasse.exposition')}
            />
          </div>
        )}

        <label className="flex items-center gap-2 text-sm text-slate-700">
          <input
            type="checkbox"
            checked={!!data?.equipements?.balcon?.surface_m2}
            onChange={(e) => {
              if (!e.target.checked) {
                onChange('equipements.balcon', null);
              } else {
                onChange('equipements.balcon.surface_m2', 0);
              }
            }}
            className="rounded border-slate-300"
          />
          Balcon
        </label>

        {data?.equipements?.balcon && (
          <div className="pl-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            <Input
              label="Surface (m²)"
              name="equipements.balcon.surface_m2"
              type="number"
              value={val('equipements.balcon.surface_m2')}
              onChange={handleChange('equipements.balcon.surface_m2')}
            />
            <Input
              label="Revêtement"
              name="equipements.balcon.revetement"
              value={val('equipements.balcon.revetement')}
              onChange={handleChange('equipements.balcon.revetement')}
            />
            <Input
              label="Exposition"
              name="equipements.balcon.exposition"
              value={val('equipements.balcon.exposition')}
              onChange={handleChange('equipements.balcon.exposition')}
            />
          </div>
        )}
      </section>

    </div>
  );
}
